var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.consultado,
                    expression: "consultado"
                  }
                ],
                staticClass: "btn-success btn--bigger",
                on: { click: _vm.guardar }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(" "),
                _c("span", [_vm._v("Guardar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.consultado,
                    expression: "consultado"
                  }
                ],
                staticClass: "btn-warning btn--bigger",
                on: { click: _vm.cancelar }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _vm._v(" "),
                _c("span", [_vm._v("Cancelar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.consultado,
                    expression: "!consultado"
                  }
                ],
                staticClass: "btn-info btn--bigger",
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-primary btn--bigger",
                on: { click: _vm.irACierres }
              },
              [
                _c("i", { staticClass: "fa fa-table" }),
                _vm._v(" "),
                _c("span", [_vm._v("Ir a consulta de cierres")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("label", { attrs: { for: "alafecha" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      disabled: _vm.consultado,
                      value: "F",
                      type: "radio",
                      name: "tipo_fecha",
                      id: "alafecha"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "F") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "F")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("A la fecha")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "hoy" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      disabled: _vm.consultado,
                      value: "H",
                      type: "radio",
                      name: "tipo_fecha",
                      id: "hoy"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "H")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "ayer" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      disabled: _vm.consultado,
                      value: "A",
                      type: "radio",
                      name: "tipo_fecha",
                      id: "ayer"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "personalizado" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      disabled: _vm.consultado,
                      value: "P",
                      type: "radio",
                      name: "tipo_fecha",
                      id: "personalizado"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
                    on: {
                      change: [
                        function($event) {
                          return _vm.$set(_vm.form, "tipo_fecha", "P")
                        },
                        _vm.changePersonalizado
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          disabled: _vm.consultado,
                          id: "fecha_inicio",
                          label: "YYYY-MM-DD",
                          locale: "es",
                          "no-label": "",
                          "only-date": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD"
                        },
                        model: {
                          value: _vm.form.fecha_inicio,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fecha_inicio", $$v)
                          },
                          expression: "form.fecha_inicio"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "fecha_inicio" } }, [
                        _vm._v("Desde")
                      ]),
                      _vm._v(" "),
                      _vm.errores.fecha_inicio
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.fecha_inicio[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          disabled: _vm.consultado,
                          id: "fecha_corte",
                          locale: "es",
                          "no-label": "",
                          "only-date": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          label: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD"
                        },
                        model: {
                          value: _vm.form.fecha_corte,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fecha_corte", $$v)
                          },
                          expression: "form.fecha_corte"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "fecha_corte" } }, [
                        _vm._v("Hasta")
                      ]),
                      _vm._v(" "),
                      _vm.errores.fecha_corte
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.fecha_corte[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-2" }, [
              _c("p", [
                _c("label", { attrs: { for: "todos_doctores" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.todos_doctores,
                        expression: "form.todos_doctores"
                      }
                    ],
                    attrs: {
                      disabled: _vm.consultado,
                      type: "checkbox",
                      name: "todos_doctores",
                      id: "todos_doctores"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.form.todos_doctores)
                        ? _vm._i(_vm.form.todos_doctores, null) > -1
                        : _vm.form.todos_doctores
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.form.todos_doctores,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "todos_doctores",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "todos_doctores",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "todos_doctores", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Todos los médicos")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.form.todos_doctores,
                    expression: "!form.todos_doctores"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "form-field select2",
                    class: {
                      "select2--disabled": _vm.consultado
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "select2-field select2-field--stretch" },
                      [
                        _c("v-select", {
                          attrs: {
                            multiple: "",
                            placeholder: "Seleccione...",
                            id: "doctor",
                            options: _vm.doctores,
                            label: "nombre_cabecera"
                          },
                          on: { input: _vm.inputDoctores },
                          model: {
                            value: _vm.selectedDoctores,
                            callback: function($$v) {
                              _vm.selectedDoctores = $$v
                            },
                            expression: "selectedDoctores"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "doctor" } }, [
                          _vm._v("Médicos")
                        ]),
                        _vm._v(" "),
                        _vm.errores.doctor_id
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.doctor_id[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.doctoresCierre, function(doctor, index) {
        return _c("div", { key: doctor.id, staticClass: "row mt-2" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("item-cierre-pago", {
                attrs: {
                  titulo: _vm.doctoresCierre[index].doctor,
                  index: index
                },
                model: {
                  value: _vm.doctoresCierre[index].cierres,
                  callback: function($$v) {
                    _vm.$set(_vm.doctoresCierre[index], "cierres", $$v)
                  },
                  expression: "doctoresCierre[index].cierres"
                }
              })
            ],
            1
          )
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [_vm._v(_vm._s(_vm.totalConsultas))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.valorTotalConsultas)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.valorFinalCancelar)))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "textarea-field",
                        {
                          attrs: {
                            id: "observacion",
                            placeholder: "Escriba una observación..."
                          },
                          model: {
                            value: _vm.observacion,
                            callback: function($$v) {
                              _vm.observacion = $$v
                            },
                            expression: "observacion"
                          }
                        },
                        [
                          _c("span", [_vm._v("Observación*")]),
                          _vm._v(" "),
                          _vm.errores.observacion
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.observacion[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Cierre de pagos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de cierre")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales generales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Total de consultas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor total en consultas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor final a cancelar")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bf7f2ff", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf7f2ff","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/CierrePago.vue
// module id = 588
// module chunks = 0